import {Component, Input} from '@angular/core';
import {
  ClockInReportItemDayDto,
  ClockInReportItemDto, ClockInReportItemEntryDto
} from '../../../../../Models/Reports/Rrhh/clock-in-report.interface';

@Component({
  selector: 'app-clock-in-report-item',
  templateUrl: './clock-in-report-item.component.html',
  styleUrls: ['./clock-in-report-item.component.scss'],
  standalone: false,
})
export class ClockInReportItemComponent {
  @Input() item!: ClockInReportItemDto;

  get hasAutomatic(): boolean {
    const days: ClockInReportItemDayDto[] = this.item?.days || [];
    return days.some((day) => day.entries.some((e: ClockInReportItemEntryDto) => e.automatic)) || false;
  }
}
